import { SizingFilter } from 'generated/maya.types';

const sizingFilterKeys = Object.keys(SizingFilter);
const sizingFilterValues = Object.values(SizingFilter);
const sizingFilterOptions = sizingFilterValues.map(
  (value, index) => { return { id: sizingFilterKeys[index], label: value }; },
);

export default sizingFilterOptions;
